import { SpinePlayer } from '@esotericsoftware/spine-player'
import { JSX, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

import { BackButton, MainButton, View, useIsFirstRender } from '@ds'
import { MainLayout } from '@shared'

import styles from './ShadowView.module.scss'


export function ShadowView(): JSX.Element | null {
  const navigate = useNavigate()

  const animaRef = useRef(null)
  const isFirstRender = useIsFirstRender()

  useEffect(() => {
    if (isFirstRender && animaRef.current) {
      const spinePlayer = new SpinePlayer(animaRef.current, {
        preserveDrawingBuffer: true,
        animation: 'animation',
        showControls: false,
        premultipliedAlpha: true,
        alpha: true,
        viewport: {
          height: 110,
          width: 110,
          padLeft: 0,
          padRight: 0,
          padTop: 0,
          padBottom: 0,
        },

        atlasUrl: `https://notway.fra1.cdn.digitaloceanspaces.com/demo/Angel.atlas.txt`,
        jsonUrl: `https://notway.fra1.cdn.digitaloceanspaces.com/demo/Angel.json`,
      })
    }
  }, [animaRef.current])

  return (
    <MainLayout>
      <BackButton onClick={() => navigate('/')} />
      <MainButton hidden />

      <View fadeIn className={styles.view}>
        <div className={styles.shadow} ref={animaRef}></div>
      </View>
    </MainLayout>
  )
}
